/* unplugin-vue-components disabled */import { render } from "./GcuConsultScreen.vue?vue&type=template&id=4274ef9a&scoped=true&ts=true"
import script from "./GcuConsultScreen.vue?vue&type=script&lang=ts"
export * from "./GcuConsultScreen.vue?vue&type=script&lang=ts"

import "./GcuConsultScreen.vue?vue&type=style&index=0&id=4274ef9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4274ef9a"]])

export default __exports__